import { render, staticRenderFns } from "./GiftRecord.vue?vue&type=template&id=708cd7cf&scoped=true&"
import script from "./GiftRecord.vue?vue&type=script&lang=js&"
export * from "./GiftRecord.vue?vue&type=script&lang=js&"
import style0 from "./GiftRecord.vue?vue&type=style&index=0&id=708cd7cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708cd7cf",
  null
  
)

export default component.exports